import React from 'react';
import Title from '../../../atoms/Title';
import { useTranslation } from 'react-i18next';

export default function Mapsection({mapLink,height}) {
  const { t } = useTranslation();
  
  return (
    <div className=" bg-re-100 h-fit md:h-fit bg-rd-400">
      <div className="h-1/6 flex justify-start items-center ms-[25px]">
        <div className="pb-[8px] md:py-9">
          <Title primary>{t("home.map.title")}</Title>
        </div>
        <div className="h-[3px] w-full bg-[#F5F5F5] mx-[10px] md:mx-[20px] lg:mx-[80px]"></div>
      </div>

      {/* <div className="bg-yello-800 h-[400px] md:h-5/6 flex justify-center items-center mx-[10px] md:mx-[60px] pb-[30px] "> */}
      <div className={`bg-yelow-800 h-[600px] flex justify-center items-center mx-[10px] md:mx-[60px] pb-[30px] ${height}`}>
        
          <iframe
            src={mapLink}
            title='map'
            className="w-full h-full rounded-[8px] border border-amber"
            allowFullScreen=""
            loading="lazy"
          >

          </iframe>
      </div>
    </div>
  );
}
